import { useAppStore } from "@hooks/useAppStore";
import { isWeb } from "@memorang/helpers/platform";
import { useMemo } from "react";
import { usePracticeTestsContext } from "../../contexts/PracticeTestsContext";

export const useRecommendedTestInventory = () => {
	const {
		loading: isLoading,
		practiceTestDistribution: itemDistribution,
		handlePracticeTestSession,
		selectedExamId,
		creatingSession,
	} = usePracticeTestsContext();
	const enabledData = useAppStore((state) => state.exam.practiceTest.enabled);
	const enabled = isWeb
		? enabledData.web
		: enabledData.mobile && Boolean(itemDistribution);
	const allTests = enabled ? (itemDistribution?.exams ?? []) : [];
	const examCollectionIds = useMemo(
		() => allTests.map(({ collectionId }) => collectionId),
		[allTests],
	);

	return {
		isLoading,
		allTests,
		examCollectionIds,
		handlePracticeTestSession,
		selectedExamId,
		creatingSession,
	};
};

export type RecommendedTestInventory = ReturnType<
	typeof useRecommendedTestInventory
>;
